import { useCallback } from 'react';
import { useConversions } from './useConversions';
import { useHandleCreateConversion } from './useHandleCreateConversion';

export const useCreateNewConversionEvent = ({ goNext, handleSetCurrentIndex, setFocusedConversionId }) => {
    const handleCreateConversion = useHandleCreateConversion();
    const { conversions } = useConversions();

    const handleNewEventButton = useCallback(() => {
        const newConversionId = handleCreateConversion();
        const newIndex = conversions ? conversions.length : 0;
        handleSetCurrentIndex(newIndex);
        goNext();
        setFocusedConversionId(newConversionId);
    }, [handleCreateConversion, conversions, handleSetCurrentIndex, goNext, setFocusedConversionId]);

    return {
        handleNewEventButton,
    };
};
